import { useLoadingStore } from "./loading.store";

export type LoadingHandle = { hide: () => void };

export function useLoading() {
  const store = useLoadingStore();

  function show(label?: string, fullscreen?: boolean): LoadingHandle {
    store.show(label, fullscreen);
    return { hide: () => store.hide() };
  }

  return {
    state: store.state,
    show,
    hide: store.hide,
    reset: store.reset,
  };
}
